import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import { useAppState, uuidv4 } from '../../state';

import { ThemeProvider, withStyles, createMuiTheme, makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import 'survey-react/survey.css';
import 'survey-react/modern.css';

import 'jquery-ui/themes/base/all.css';
import 'nouislider/distribute/nouislider.css';
import 'select2/dist/css/select2.css';
import 'bootstrap-slider/dist/css/bootstrap-slider.css';

//show progress stuff
// @ts-ignore
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader';

//import Snackbar from '@material-ui/core/Snackbar';
//import MuiAlert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
//import Dialog from '@material-ui/core/Dialog';
//import DialogActions from '@material-ui/core/DialogActions';
//import DialogContent from '@material-ui/core/DialogContent';
//import DialogContentText from '@material-ui/core/DialogContentText';
//import DialogTitle from '@material-ui/core/DialogTitle';

//import { green, purple, common } from '@material-ui/core/colors';
//import { any } from 'prop-types';

import * as Survey from 'survey-react';
//import * as widgets from "surveyjs-widgets";

//function Alert(props:any) {
//    return <MuiAlert elevation={6} variant="filled" {...props} />;
//}

export function getFormattedDate(date: Date) {
  //var d = new Date();

  ////"2020-07-07T10:41:01.9-0400"

  //const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
  //const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
  //const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
  //const hr = new Intl.DateTimeFormat('en-US', { hour: 'numeric' }).format(d);
  //const mn = new Intl.DateTimeFormat('en', { minute: '2-digit' }).format(d);
  //const sc = new Intl.DateTimeFormat('en', { second: '2-digit' }).format(d);
  ////const ms = new Intl.DateTimeFormat('en', { s: '2-digit' }).format(d);
  //const ms = d.getMilliseconds();

  const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  var [
    { value: month },
    ,
    { value: day },
    ,
    { value: year },
    ,
    { value: hour },
    ,
    { value: minute },
    ,
    { value: second },
  ] = dateTimeFormat.formatToParts(date);

  var ms = ('000' + date.getMilliseconds()).slice(-3);

  //console.log(date.toISOString());
  //var tz = date.getTimezoneOffset();
  if (hour === '24') {
    hour = '00';
  }

  var surveystartstring = `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}`;

  //console.log(surveystartstring);

  return surveystartstring;
  //console.log(surveystartstring);
}

export function getFormattedDateSale(date: Date) {
  //var d = new Date();

  ////"2020-07-07T10:41:01.9-0400"

  //const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
  //const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
  //const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
  //const hr = new Intl.DateTimeFormat('en-US', { hour: 'numeric' }).format(d);
  //const mn = new Intl.DateTimeFormat('en', { minute: '2-digit' }).format(d);
  //const sc = new Intl.DateTimeFormat('en', { second: '2-digit' }).format(d);
  ////const ms = new Intl.DateTimeFormat('en', { s: '2-digit' }).format(d);
  //const ms = d.getMilliseconds();

  const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  var [
    { value: month },
    ,
    { value: day },
    ,
    { value: year },
    ,
    { value: hour },
    ,
    { value: minute },
    ,
    { value: second },
  ] = dateTimeFormat.formatToParts(date);

  var ms = ('000' + date.getMilliseconds()).slice(-3);

  //console.log(date.toISOString());
  //var tz = date.getTimezoneOffset();
  if (hour === '24') {
    hour = '00';
  }

  var surveystartstring = `${hour}${minute}${second}`;

  //console.log(surveystartstring);

  return surveystartstring;
  //console.log(surveystartstring);
}

//function getKeyByValue(object: any, value: any) {
//  return Object.keys(object).find(key => object[key] === value);
//}

//function isContactInfoQuestion(variable: string) {
//  if (
//    variable === '$FIRST_NAME' ||
//    variable === '$LAST_NAME' ||
//    variable === '$ADDRESS' ||
//    variable === '$APARTMENT' ||
//    variable === '$CITY' ||
//    variable === '$STATE' ||
//    variable === '$ZIP' ||
//    variable === '$HOME' ||
//    variable === '$CELL' ||
//    variable === '$EMAIL'
//  ) {
//    return true;
//  }

//  return false;
//}

//function getDefaultSurveyValue(variable: string, object: any) {
//  var inputtype = '';

//  switch (variable) {
//    case '$FIRST_NAME':
//      inputtype = object.FirstName;
//      break;

//    case '$LAST_NAME':
//      inputtype = object.LastName;
//      break;

//    case '$ADDRESS':
//      inputtype = object.Address;
//      break;

//    case '$APARTMENT':
//      inputtype = object.Apartment;
//      break;

//    case '$CITY':
//      inputtype = object.City;
//      break;

//    case '$STATE':
//      inputtype = object.State;
//      break;

//    case '$ZIP':
//      inputtype = object.Zip;
//      break;

//    case '$HOME':
//      inputtype = object.Phone;
//      break;

//    case '$CELL':
//      inputtype = object.Cell;
//      break;

//    case '$EMAIL':
//      inputtype = object.Email;
//      break;
//  }

//  return inputtype;
//}

//function isContactInfoSameLine(variable: string) {
//  if (variable === '$LAST_NAME' || variable === '$STATE' || variable === '$ZIP' || variable === '$CELL') {
//    return true;
//  }

//  return false;
//}

//function getContactInfoInputType(variable: string) {
//  var inputtype = '';

//  switch (variable) {
//    case '$ZIP':
//      inputtype = 'number';
//      break;

//    case '$HOME':
//      inputtype = 'number';
//      break;

//    case '$CELL':
//      inputtype = 'number';
//      break;
//  }

//  return inputtype;
//}

//function uuidv4() {
//  // @ts-ignore
//  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
//    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
//  );
//}

export default function SurveyView() {
  const {
    //petition,
    petitionjson,
    //sendAnswers,
    loggedUsername,
    walklistjson,
    setWalklist,
    //surveySent,
    server,
    loggedImei,
    surveyModel,
    surveyStartString,
    surveyMobileID,
    surveySubject,
    surveyExecuteSale,
    surveyPublic,
    setSurveyExecuteSale,
    surveyExecuteSaleValid,
    setSurveyExecuteSaleValid,
  } = useAppState();

  //var [surveysentlocal, setsurveylocal] = useState();
  //const [isSurveyComplete, setSurveyComplete] = useState(false);
  //const uuid4 = uuidv4();
  var [accountNumber, setAccountNumber] = useState('');
  var [routeNumber, setRouteNumber] = useState('');
  var [amount, setAmount] = useState(0);
  var [paymentType, setPaymentType] = useState('Credit Card');
  var [recurring, setRecurring] = useState('ONE-TIME');
  var [localToken, setLocalToken] = useState('');
  //var [uuid4Cookie, setUuid4Cookie] = useState(uuidv4());

  //const petitionparse = JSON.parse(petition);

  //var surveystartstring = getFormattedDate(new Date());

  //const gruquestions = petitionjson.Questions;

  const gruquestions = [].slice.call(petitionjson.Questions).sort(function(a: any, b: any) {
    return a.Order - b.Order;
  });

  const gruquestionanswers = petitionjson.Answers;
  const petitionid = petitionjson.Id;

  //var localToken = '';
  //var executeSale = false;
  //const petitionparse = JSON.parse(petition);

  //var surveystartstring = getFormattedDate(new Date());

  //var foundcontactinfo = false;

  ////console.log(gruquestionanswers);

  //Object.keys(gruquestions).forEach(function(key) {
  //  if (gruquestions[key].Type === 'ContactInfo') {
  //    foundcontactinfo = true;
  //  }
  //});

  //var questionsarr: any = [];
  //var questionscontactinfoarr: any = [];

  //Object.keys(gruquestions).forEach(function(key) {
  //  var element = {
  //    type: '',
  //    name: '',
  //    isRequired: false,
  //    startWithNewLine: true,
  //    title: '',
  //    choices: [],
  //  };

  //  element.name = gruquestions[key].Id.toString();
  //  element.title = gruquestions[key].Text ? gruquestions[key].Text : gruquestions[key].Title;

  //  if (gruquestions[key].Required) {
  //    element.isRequired = true;
  //  }

  //  if (gruquestions[key].Type === 'ContactInfo') {
  //    foundcontactinfo = true;
  //  } else if (gruquestions[key].Type === 'FreeFormSingleLine') {
  //    element.type = 'text';
  //  } else if (gruquestions[key].Type === 'Email') {
  //    element.type = 'text';
  //  } else if (gruquestions[key].Type === 'QueueCard') {
  //    element.type = 'html';

  //    var htmllocal = '';

  //    Object.keys(gruquestionanswers).forEach(function(key) {
  //      if (gruquestionanswers[key].Question.toString() === element.name) {
  //        htmllocal = gruquestionanswers[key].Value;
  //      }
  //    });

  //    // @ts-ignore */
  //    element.html = htmllocal;
  //  } else if (gruquestions[key].Type === 'FreeFormMultiLine') {
  //    element.type = 'text';
  //  } else if (gruquestions[key].Type === 'Standard') {
  //    element.type = 'radiogroup';

  //    var choiceslocal: any = [];

  //    Object.keys(gruquestionanswers).forEach(function(key) {
  //      if (gruquestionanswers[key].Question.toString() === element.name) {
  //        choiceslocal.push(gruquestionanswers[key].Value);
  //      }
  //    });

  //    //console.log(choiceslocal);
  //    element.choices = choiceslocal;
  //  } else if (gruquestions[key].Type === 'Checkbox') {
  //    //element.type = "checkbox";
  //    //radiogroup for now
  //    element.type = 'radiogroup';

  //    var choiceslocal: any = [];

  //    Object.keys(gruquestionanswers).forEach(function(key) {
  //      if (gruquestionanswers[key].Question.toString() === element.name) {
  //        choiceslocal.push(gruquestionanswers[key].Value);
  //      }
  //    });

  //    element.choices = choiceslocal;
  //  }

  //  if (surveySubject !== null) {
  //    // @ts-ignore
  //    element.defaultValue = getDefaultSurveyValue(gruquestions[key].Variable, surveySubject);
  //  }

  //  if (foundcontactinfo && isContactInfoQuestion(gruquestions[key].Variable)) {
  //    if (isContactInfoSameLine(gruquestions[key].Variable)) {
  //      element.startWithNewLine = false;
  //    }

  //    if (getContactInfoInputType(gruquestions[key].Variable) !== '') {
  //      // @ts-ignore
  //      element.inputType = getContactInfoInputType(gruquestions[key].Variable);
  //    }

  //    questionscontactinfoarr.push(element);
  //  } else {
  //    questionsarr.push(element);
  //  }
  //});

  //console.log(questionscontactinfoarr);

  //var pages: any = [];

  //if (foundcontactinfo) {
  //  pages.push({
  //    name: 'Contact Info',
  //    title: 'Contact Info',
  //    elements: questionscontactinfoarr,
  //  });
  //}

  //for (const [index, value] of questionsarr.entries()) {
  //  var localarray: any = [];

  //  var pagetemp = {
  //    name: '',
  //    title: '',
  //    elements: [],
  //  };

  //  if (value.type !== '') {
  //    pagetemp.name = value.name;
  //    //pagetemp.title = value.title;
  //    localarray.push(value);
  //    pagetemp.elements = localarray;
  //    pages.push(pagetemp);
  //  }
  //}

  ////all on one page
  ////var jsontest2 = {
  ////    "title": "New Grassroots Survey",
  ////    "pages": [
  ////        {
  ////            "name": "Contact Info",
  ////            "title": "Contact Info",
  ////            "elements": questionsarr
  ////        }
  ////    ]
  ////};

  //var surveyTitle = 'New Grassroots Survey';
  //if (surveySubject !== null) {
  //  surveyTitle = 'Survey for ' + surveySubject.FirstName + ' ' + surveySubject.LastName;
  //}

  ////all on separate pages
  //var jsontest = {
  //  //cookieName: mobileSurveyId,
  //  title: surveyTitle,
  //  pages: pages,
  //};

  //Survey.StylesManager.applyTheme('modern');

  //html: "<iframe src='http://localhost:3000' height='200' width='300' onload='alert(\"test\")' title='Iframe Example' onload='alert('test')'></iframe>"
  //html: "<iframe src='http://localhost:3000' height='200' width='300' onload='handleJS()' title='Iframe Example'></iframe>"

  //var jsonpetition = { "Id": 12963, "Name": "Xamarin Walklist", "Introduction": null, "Signature": false, "Walklist": true, "CreditCheck": false, "Petition": "", "Questions": [{ "Id": 109690, "TypeId": 3, "Order": 1, "Required": true, "Magic": false, "Title": "First Name", "Type": "FreeFormSingleLine", "Text": "", "Variable": "$FIRST_NAME", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": 1 }, { "Id": 109691, "TypeId": 3, "Order": 2, "Required": false, "Magic": false, "Title": "Last Name", "Type": "FreeFormSingleLine", "Text": "", "Variable": "$LAST_NAME", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": 1 }, { "Id": 109692, "TypeId": 3, "Order": 3, "Required": false, "Magic": false, "Title": "Address", "Type": "FreeFormSingleLine", "Text": "", "Variable": "$ADDRESS", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": 1 }, { "Id": 109693, "TypeId": 3, "Order": 4, "Required": false, "Magic": false, "Title": "Apartment", "Type": "FreeFormSingleLine", "Text": null, "Variable": "$APARTMENT", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": 1 }, { "Id": 109694, "TypeId": 3, "Order": 5, "Required": false, "Magic": false, "Title": "City", "Type": "FreeFormSingleLine", "Text": "", "Variable": "$CITY", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": 1 }, { "Id": 109695, "TypeId": 3, "Order": 6, "Required": false, "Magic": false, "Title": "State", "Type": "FreeFormSingleLine", "Text": "", "Variable": "$STATE", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": 1 }, { "Id": 109696, "TypeId": 3, "Order": 7, "Required": false, "Magic": false, "Title": "Zip", "Type": "FreeFormSingleLine", "Text": "", "Variable": "$ZIP", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": 1 }, { "Id": 109697, "TypeId": 3, "Order": 8, "Required": false, "Magic": false, "Title": "Home", "Type": "FreeFormSingleLine", "Text": null, "Variable": "$HOME", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": 1 }, { "Id": 109698, "TypeId": 3, "Order": 9, "Required": false, "Magic": false, "Title": "Cell", "Type": "FreeFormSingleLine", "Text": null, "Variable": "$CELL", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": 1 }, { "Id": 109699, "TypeId": 12, "Order": 10, "Required": false, "Magic": false, "Title": "ContactInfo", "Type": "ContactInfo", "Text": null, "Variable": "$ContactInfo", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": 1 }, { "Id": 109706, "TypeId": 5, "Order": 9, "Required": false, "Magic": true, "Title": "Email", "Type": "FreeFormSingleLine", "Text": "Email", "Variable": "$ANSWER-7", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": null }, { "Id": 109708, "TypeId": 7, "Order": 45, "Required": false, "Magic": false, "Title": "Picture Question", "Type": "Picture", "Text": "If you support our cause, please take a picture and help us.", "Variable": "$ANSWER-4", "QuestionTally": false, "Restrictions": "[]", "Hidden": false, "EnableBarcode": false, "Branch": 0, "MinAnswers": 0, "MaxAnswers": null }], "Answers": [], "UserFirstName": "ani", "UserLastName": "xamarin", "POS": false, "Products": null, "Reservation": false, "Bidirectional": true, "LocationList": false, "ScriptProperties": [{ "Id": 25761, "PetitionId": 12963, "Name": "VOIP_FROM_NUMBER", "Value": "+12153213749", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25762, "PetitionId": 12963, "Name": "TEXT_FROM_NUMBER", "Value": "+12672027058", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25760, "PetitionId": 12963, "Name": "VOIP_APP_ID", "Value": "APef4d8d0dcaa2db2b0c6e5b6a0963f72c", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25763, "PetitionId": 12963, "Name": "TEXT_PREDEFINED", "Value": "Be there soon!||At front door", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25764, "PetitionId": 12963, "Name": "validateEmail", "Value": "false", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25765, "PetitionId": 12963, "Name": "validateHome", "Value": "false", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25768, "PetitionId": 12963, "Name": "EnablePictureFrame", "Value": "true", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25769, "PetitionId": 12963, "Name": "PictureFrameTextColor", "Value": "#FFFF00", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25753, "PetitionId": 12963, "Name": "SupportedLanguages", "Value": "{\"English\":\"en\"}", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25754, "PetitionId": 12963, "Name": "BackupPaymentProcessingEnabled", "Value": "False", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25766, "PetitionId": 12963, "Name": "ValidateCell", "Value": "false", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25770, "PetitionId": 12963, "Name": "PictureFrameTextSize", "Value": "20", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25771, "PetitionId": 12963, "Name": "PictureFrameBackground", "Value": "#9400D3", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25772, "PetitionId": 12963, "Name": "PictureFrameText", "Value": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. \\nLorem Ipsum has been the industry's standard dummy\\n text ever since the 1500s, when an unknown printer took a galley of type and \\nscrambled it to make\\n a type specimen book. It has survived not only five centuries, but also\\n the leap into electronic typesetting, remaining\\n essentially unchanged. It was popularised\\n in the 1960s with the release of\\n Letraset sheets containing Lorem Ipsum passages, and more recently\\n with desktop publishing software like \\nAldus PageMaker including versions\\n of Lorem Ipsum.", "PropertyType": 3, "Data": null, "ContentType": null }, { "Id": 25767, "PetitionId": 12963, "Name": "PDFStamp", "Value": "https://gru-content.s3.amazonaws.com/staging.grassrootsunwired.com/12963/test.pdf", "PropertyType": 5, "Data": null, "ContentType": null }], "QuestionProperties": [], "AnswerProperties": [], "ProductProperties": [], "UserProperties": [], "KnockStatuses": [{ "Name": "Not Knocked", "Description": null, "LocalId": 0, "CategoryType": 1, "CategoryName": "Do-Over", "DisplayOrder": 10, "Color": null }, { "Name": "Not Home", "Description": null, "LocalId": 1, "CategoryType": 1, "CategoryName": "Do-Over", "DisplayOrder": 20, "Color": null }, { "Name": "Refused", "Description": null, "LocalId": 2, "CategoryType": 2, "CategoryName": "Overcome By Events", "DisplayOrder": 30, "Color": null }, { "Name": "Inaccessible", "Description": null, "LocalId": 3, "CategoryType": 2, "CategoryName": "Overcome By Events", "DisplayOrder": 40, "Color": null }, { "Name": "Deceased", "Description": null, "LocalId": 4, "CategoryType": 2, "CategoryName": "Overcome By Events", "DisplayOrder": 50, "Color": null }, { "Name": "Moved", "Description": null, "LocalId": 5, "CategoryType": 2, "CategoryName": "Overcome By Events", "DisplayOrder": 60, "Color": null }, { "Name": "Language Barrier", "Description": null, "LocalId": 6, "CategoryType": 2, "CategoryName": "Overcome By Events", "DisplayOrder": 70, "Color": null }, { "Name": "Not an Address", "Description": null, "LocalId": 8, "CategoryType": 2, "CategoryName": "Overcome By Events", "DisplayOrder": 80, "Color": null }, { "Name": "Vacant or For Sale", "Description": null, "LocalId": 10, "CategoryType": 2, "CategoryName": "Overcome By Events", "DisplayOrder": 90, "Color": null }, { "Name": "Come Back Later", "Description": null, "LocalId": 13, "CategoryType": 1, "CategoryName": "Do-Over", "DisplayOrder": 100, "Color": null }, { "Name": "Canvassed", "Description": null, "LocalId": 14, "CategoryType": 0, "CategoryName": "Done", "DisplayOrder": 110, "Color": null }], "CampaignID": 1366, "CampaignName": "GRU Internal", "CrewNotes": "", "IsTraining": false, "LocationName": "Area 51" }
  //var iframe = "<iframe id = 'iframe1' src = 'http://localhost:3000' height = '500' width = '500' title = 'Iframe Example'></iframe>";

  //console.log(iframe);

  //var json = {
  //    "title": "New Grassroots Survey",
  //    "pages": [
  //        {
  //            "name": "Contact Info",
  //            "title": "Contact Info",
  //            "elements": [
  //                {
  //                    type: "text",
  //                    name: "first",
  //                    isRequired: true,
  //                    title: "First Name"
  //                },
  //                {
  //                    type: "text",
  //                    name: "last",
  //                    isRequired: true,
  //                    startWithNewLine: false,
  //                    title: "Last Name"
  //                },
  //                {
  //                    type: "text",
  //                    name: "address1",
  //                    title: "Address"
  //                }, {
  //                    type: "text",
  //                    name: "address2",
  //                    title: "Address 2"
  //                }, {
  //                    type: "text",
  //                    name: "city",
  //                    title: "City"
  //                }, {
  //                    type: "text",
  //                    name: "state",
  //                    startWithNewLine: false,
  //                    title: "State"
  //                }, {
  //                    type: "text",
  //                    name: "zip",
  //                    startWithNewLine: false,
  //                    title: "Zip"
  //                }
  //            ]
  //        },  {
  //            "name": "page2",
  //            "elements": [
  //                {
  //                    "type": "signaturepad",
  //                    "name": "signature",
  //                    "title": "Please sign"
  //                }
  //            ]
  //        },  {
  //            "name": "page3",
  //            "elements": [
  //                {
  //                    type: "html",
  //                    name: "info1",
  //                    html: "<table><body><row><td><img src='/Content/Images/examples/26178-20160417.jpg' width='100px' /></td><td style='padding:20px'>You may put here any html code. For example images, <b>text</b> or <a href='https://surveyjs.io/create-survey'  target='_blank'>links</a></td></row></body></table>"
  //                }
  //            ]
  //        },  {
  //            "name": "page4",
  //            "elements": [
  //                {
  //                    type: "html",
  //                    name: "info2",
  //                    html: "<iframe src='http://localhost:3000' height='500' width='500' title='Iframe Example'></iframe><iframe src='http://localhost:2999' height='500' width='500' onload='alert(\"loaded\")' title='Iframe Example'></iframe>"
  //                }
  //            ]
  //        },  {
  //            "name": "page4.5",
  //            "elements": [
  //                {
  //                    type: "html",
  //                    name: "info3",
  //                    html: iframe,//"<iframe id='iframe1' src='http://localhost:3000' ref={ref} onload='alert(this.src)' height='500' width='500' title='Iframe Example'></iframe>"
  //                }
  //            ]
  //        },  {
  //            "name": "page4.7",
  //            "elements": [
  //                {
  //                    type: "html",
  //                    name: "info4",
  //                    html: "<iframe id='iframe2' src='https://staging.grassrootsunwired.com/PaymentRequest.aspx?' height='500' width='500' title='Iframe Example'></iframe>"
  //                }
  //            ]
  //        },  {
  //            "name": "page4.8",
  //            "elements": [
  //                {
  //                    type: "html",
  //                    name: "info5",
  //                    html: "<iframe id='iframe3' src='http://localhost:63446/PaymentRequest.aspx?' height='500' width='500' title='Iframe Example'></iframe>"
  //                }
  //            ]
  //        },  {
  //            "name": "page5",
  //            "elements": [
  //                {
  //                    "type": "multipletext",
  //                    "name": "contact_customer",
  //                    "title": "Want us to follow-up? Leave your name and email here:",
  //                    "items": [
  //                        {
  //                            "name": "Name"
  //                        }, {
  //                            "name": "E-mail",
  //                            "inputType": "email",
  //                            "validators": [
  //                                {
  //                                    "type": "email"
  //                                }
  //                            ]
  //                        }
  //                    ]
  //                }
  //            ]
  //        }
  //    ]
  //};

  //old method
  //var surveylocal = new Survey.Model(jsontest);
  //var surveylocal = surveyModel;

  ////one method to branch by dynamically adding or removing pages
  ////surveylocal.removePage(surveylocal.getPageByName("Contact Info"));

  ////onNextPage is default mode
  //surveylocal.checkErrorsMode = 'onValueChanged';

  //surveylocal.showPageNumbers = false;

  ////noPreview is default, showAllQuestions is another option
  //surveylocal.showPreviewBeforeComplete = 'showAnsweredQuestions';

  //surveylocal.showProgressBar = 'top';
  ////surveylocal.showTimerPanel = "top";
  //surveylocal.showQuestionNumbers = 'off';

  ////options are none, onComplete, onHidden.  OnHidden will prevent answers being sent that shouldnt be sent, more tedious if canvasser
  ////messes up but safer in the end.
  //surveylocal.clearInvisibleValues = 'onHidden';

  const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
      maxWidth: 752,
    },
    demo: {
      backgroundColor: theme.palette.background.paper,
    },
    title: {
      margin: theme.spacing(4, 0, 2),
    },
    survey: {
      backgroundColor: '#ffffff',
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
    loading: {
      height: '100%',
      width: '100%',
      //display: 'flex',
    },
  }));

  const classes = useStyles();

  var unHideMap = new Map<string, string[]>();
  //var unHideMap = React.useState(new Map<string,string[]>());

  function onValueChanged(result: Survey.SurveyModel, options: any) {
    console.log('value changed name: ' + options.name);
    console.log('value changed value: ' + options.value);
    //console.log( options.value);
    console.log('value changed question: ' + options.question.name);
    //console.log('unhide map' + unHideMap.keys());

    //restore questions for answer branching
    if (unHideMap?.has(options.question.name)) {
      console.log('unHideMap has question name: ' + options.question.name);
      var getunHide2 = unHideMap.get(options.question.name);
      if (getunHide2 !== undefined) {
        getunHide2.forEach(function(value) {
          result.getQuestionByName(value).visible = true;
          console.log('making question visible for answer branching: ' + value);
        });
        unHideMap.delete(options.question.name);
      }
    }

    //hide questions for answer branching
    Object.keys(gruquestionanswers).forEach(function(key) {
      if (
        gruquestionanswers[key].Question.toString() === options.question.name &&
        options.value &&
        options.value.text &&
        options.value.text.default &&
        gruquestionanswers[key].Value.toString() === options.value.text.default
      ) {
        // && !gruquestionanswers[key].Branch && gruquestionanswers[key].Branch > 0) {
        //alert("branch to: " + gruquestionanswers[key].Branch);
        if (gruquestionanswers[key].Branch > 0) {
          //alert("branch to: " + gruquestionanswers[key].Branch);
          var allq = result.getAllQuestions();
          var branchFound = false;
          allq.forEach(function myFunction(value, index, array) {
            if (value.name === gruquestionanswers[key].Branch.toString()) {
              branchFound = true;
            }
          });

          if (branchFound) {
            var hide: boolean = false;
            allq.forEach(function myFunction(value, index, array) {
              if (hide) {
                if (value.name !== gruquestionanswers[key].Branch.toString()) {
                  value.visible = false;
                  array[index].visible = false;
                  console.log('making question invisible for answer branching: ' + value.name);
                  var getunHide = unHideMap.get(value.name);
                  if (getunHide !== undefined) {
                    getunHide.push(value.name);
                    unHideMap.set(options.question.name, getunHide);
                  } else {
                    unHideMap.set(options.question.name, new Array(value.name));
                  }
                  //alert(value.name + " set invisible");
                } else {
                  hide = false;
                }
              } else {
                if (value.name == options.question.name) {
                  hide = true;
                }
              }
              //console.log("value: " + value.name + " index: " + index + ");
            });
          } else {
            alert('Branching question was not found.  Branching disabled.');
          }
        }
      }
    });
    //cant expect value to be changed for normal branching, but we can for answer branching
    //Object.keys(gruquestions).forEach(function(key) {
    //  if (gruquestions[key].Branch > 0 && options.question.name == gruquestions[key].Id) {
    // && (gruquestions[key].Branch != options.newCurrentPage)) {

    //alert('branch to ' + gruquestions[key].Branch + ' from ' + gruquestions[key].Id);
    //result.getQuestionByName("109723").visible = false;
    //  }
    //});

    //if (options.question.name) === 'ProductTest') {
    //console.log('changing to next page from ProductTest page');
    //Object.keys(result.data).forEach(function (key) {

    if (options.question.name === 'Recurring Products') {
      //recurring = options.value;
      setRecurring(options.value);
      setSurveyExecuteSale(true);
    } else if (options.question.name === 'Product Payment Type') {
      setPaymentType(options.value);
      setSurveyExecuteSale(true);
      setSurveyExecuteSaleValid(false);
    } else if (options.question.name === 'Checking Account Number') {
      setAccountNumber(options.value);
      setSurveyExecuteSale(true);
      setSurveyExecuteSaleValid(true);
      const local = uuidv4();
      setLocalToken(local);
    } else if (options.question.name === 'Checking Routing Number') {
      setRouteNumber(options.value);
      setSurveyExecuteSale(true);
      setSurveyExecuteSaleValid(true);
      const local = uuidv4();
      setLocalToken(local);
    } else if (options.question.name === 'One Time Products') {
      //amount = result.data[key];
      //console.log('amount set to options.value: ' + options.value);
      //console.log('amount result.data[key]: ' + result.data['One Time Products']);
      if (options.value === 'other') {
        setAmount(result.data['One Time Products-Comment']);
      } else {
        setAmount(options.value);
      }
      setSurveyExecuteSale(true);
    } else if (options.question.name === 'Weekly Products') {
      //amount = result.data[key];
      if (options.value === 'other') {
        setAmount(result.data['Weekly Products-Comment']);
      } else {
        setAmount(options.value);
      }
      setSurveyExecuteSale(true);
    } else if (options.question.name === 'Monthly Products') {
      //amount = result.data[key];
      if (options.value === 'other') {
        setAmount(result.data['Monthly Products-Comment']);
      } else {
        setAmount(options.value);
      }
      setSurveyExecuteSale(true);
    } else if (options.question.name === 'Quarterly Products') {
      //amount = result.data[key];
      if (options.value === 'other') {
        setAmount(result.data['Quarterly Products-Comment']);
      } else {
        setAmount(options.value);
      }
      setSurveyExecuteSale(true);
    } else if (options.question.name === 'Semiannual Products') {
      //amount = result.data[key];
      if (options.value === 'other') {
        setAmount(result.data['Semiannual Products-Comment']);
      } else {
        setAmount(options.value);
      }
      //setAmount(options.value);
      setSurveyExecuteSale(true);
    } else if (options.question.name === 'Annual Products') {
      //amount = result.data[key];
      if (options.value === 'other') {
        setAmount(result.data['Annual Products-Comment']);
      } else {
        setAmount(options.value);
      }
      //setAmount(options.value);
      setSurveyExecuteSale(true);
    }
    //});
    //}
  }

  //var recurring = '';
  //var amount = 0;

  function onCurrentPageChanging(result: Survey.SurveyModel, options: any) {
    if (options.isNextPage) {
      //console.log('changing to next page');
      //if (options && options.oldCurrentPage && options.oldCurrentPage.toString() === 'ProductTest') {
      //  console.log('changing to next page from ProductTest page');
      //  Object.keys(result.data).forEach(function (key) {

      //    if (key === 'Recurring Products') {
      //      recurring = result.data[key];
      //    }
      //    else if (key === 'One Time Products') {
      //      //amount = result.data[key];
      //      setAmount(result.data[key]);
      //    }
      //    else if (key === 'Weekly Products') {
      //      //amount = result.data[key];
      //      setAmount(result.data[key]);
      //    }
      //    else if (key === 'Monthly Products') {
      //      //amount = result.data[key];
      //      setAmount(result.data[key]);
      //    }
      //    else if (key === 'Annual Products') {
      //      //amount = result.data[key];
      //      setAmount(result.data[key]);
      //    }
      //  });
      //}

      console.log('current recurring: ' + recurring);
      console.log('current amount: ' + amount);
    } else if (options.isPrevPage) {
      console.log('changing to previous page');
    }
    console.log('page changed old: ' + options.oldCurrentPage);
    console.log('page changed new: ' + options.newCurrentPage);
    //set option.allowChanging = false to stop changing

    //Object.keys(gruquestions).forEach(function (key) {

    //    //if (gruquestions[key].Type === "ContactInfo") {
    //    //    foundcontactinfo = true;
    //    //}
    //    if ((gruquestions[key].Branch > 0) && (options.oldCurrentPage == gruquestions[key].Id)) {// && (gruquestions[key].Branch != options.newCurrentPage)) {

    //        //alert("branch to " + gruquestions[key].Branch + " from " + gruquestions[key].Id);
    //        //result.getQuestionByName("109723").visible = false;

    //        //doesnt work
    //        //options.newCurrentPage = gruquestions[key].Branch.toString();//"109700"

    //        //wont let me set next pages visible to false....
    //        //result.getPageByName("109723").visible = false; //options.newCurrentPage.toString()).visible = false;
    //        //result.nextPage();
    //        //let array: Survey.Question[] = result.getAllQuestions();
    //        //let arrayLength = result.getAllQuestions().length;

    //        //for (let i = 0; i < arrayLength; i++) {
    //        //    let val: Survey.Question = array[i];
    //            //console.log(val);
    //        //    if (val.name == options.newCurrentPage) //&& (gruquestions[key].Branch != options.newCurrentPage))
    //        //    {
    //        //        console.log(val);
    //                //val.visible = false;
    //        //    }

    //    }

    //});

    //setting newcurrentpage doesnt work
    //if (options.newCurrentPage == "109700") {
    //doesnt work
    //options.newCurrentPage = "109702";
    //options.allowChanging = false;
    //}
  }

  //var normalQuestionBranch = false;
  var unHideNormalQuestionBranchMap = new Map<string, string[]>();

  function onAfterRenderPage(result: Survey.SurveyModel, options: any) {
    //setOpenBackDrop(true);
    console.log('onAfterRenderPage for page: ' + options.page);

    const ClassyLink = petitionjson.ScriptProperties.find((x: any) => x.Name === 'ClassyScript');

    if (ClassyLink && options && options.htmlElement && options.htmlElement.innerHTML && options.htmlElement.innerHTML.includes('classy=')) {
        const script = document.createElement("script");

        script.src = ClassyLink.Value;
        script.async = true;
        script.id = "classyDonationJS";

        if (document.getElementById('classyDonationJS')) {
            // @ts-ignore */
            document.getElementById('classyDonationJS').remove();
            document.head.appendChild(script);
        } else {
            document.head.appendChild(script);
        }
    }


                  


    //console.log("onAfterRenderPage options.htmlelement: " + options.htmlElement);
    //console.log("onAfterRenderPage options.htmlelement.title: " + options.htmlElement.title);
    //console.log("onAfterRenderPage options.htmlelement.id: " + options.htmlElement.id);

    //Unhide questions if question is before the branching question
    //Loop map
    //var deleteKey = "";

    for (let [k, v] of unHideNormalQuestionBranchMap) {
      //Loop questions to see if we are before the normal branching question in order to unhide

      console.log(`unHideNormalQuestionBranchMap ${k}: ${v}`);

      var allq = result.getAllQuestions();
      var questionIsBeforeKey = false;
      var foundMapKey = false;
      var hideKey = '';

      allq.forEach(function myFunction(value2, index, array) {
        //console.log(`allq index ${index}: value ${value2}: k ${k}`);

        if (!foundMapKey && value2.name === options.page.toString()) {
          //hide since page is before the key page
          hideKey = k;
          var getunHide2 = v;
          if (getunHide2 !== undefined) {
            getunHide2.forEach(function(value3) {
              result.getQuestionByName(value3).visible = true;
              console.log('making question visible for normal branching: ' + value3);
            });
            //unHideMap.delete(options.question.name);
          }
          unHideNormalQuestionBranchMap.delete(hideKey);
          console.log('delete key from unHideNormalQuestionBranchMap: ' + hideKey);
          foundMapKey = true;
        } else if (k === value2.name) {
          //dont hide
          foundMapKey = true;
        }
      });
    }

    //if (hideKey !== undefined && hideKey !== '') {
    //  console.log("delete key from unHideNormalQuestionBranchMap: " + hideKey);
    //unHideNormalQuestionBranchMap.delete(hideKey);
    //hideKey = "";
    //}
    //if (unHideNormalQuestionBranchMap ?.has(options.question.name)) {
    //  console.log('unHideMap has question name: ' + options.question.name);
    //  var getunHide2 = unHideMap.get(options.question.name);
    //  if (getunHide2 !== undefined) {
    //    getunHide2.forEach(function (value) {
    //      result.getQuestionByName(value).visible = true;
    //      console.log('making question visible: ' + value);
    //    });
    //    unHideMap.delete(options.question.name);
    //  }
    //}

    //Hide questions based on normal branching if branch question is found and no individual answer branching
    Object.keys(gruquestions).forEach(function(key) {
      //console.log("key: " + key + " options.page: " + options.page + " gruquestions[key].Id.toString(): " + gruquestions[key].Id.toString() + " branch: " + gruquestions[key].Branch);
      if (gruquestions[key].Branch > 0 && options.page.toString() === gruquestions[key].Id.toString()) {
        console.log('found normal branch for this page');
        var foundAnswerBranching = false;
        Object.keys(gruquestionanswers).forEach(function(key) {
          if (gruquestionanswers[key].Question.toString() === options.page && gruquestionanswers[key].Branch > 0) {
            foundAnswerBranching = true;
          }
        });

        var allq = result.getAllQuestions();
        var foundQuestionToBranchTo = false;
        allq.forEach(function myFunction(value, index, array) {
          if (value.name === gruquestions[key].Branch.toString()) {
            foundQuestionToBranchTo = true;
          }
        });

        if (!foundAnswerBranching && foundQuestionToBranchTo) {
          var hide: boolean = false;
          allq.forEach(function myFunction(value, index, array) {
            if (hide) {
              if (value.name !== gruquestions[key].Branch.toString()) {
                value.visible = false;
                array[index].visible = false;
                console.log('making question invisible for normal branching: ' + value.name);
                var getunHide = unHideNormalQuestionBranchMap.get(value.name);
                if (getunHide !== undefined) {
                  getunHide.push(value.name);
                  unHideNormalQuestionBranchMap.set(options.page.toString(), getunHide);
                } else {
                  unHideNormalQuestionBranchMap.set(options.page.toString(), new Array(value.name));
                }
                //alert(value.name + " set invisible");
              } else {
                hide = false;
              }
            } else {
              if (value.name === options.page.toString()) {
                hide = true;
              }
            }
            //console.log("value: " + value.name + " index: " + index + ");
          });
        } else {
          if (foundAnswerBranching) {
            alert('Found answer AND question branching on same question. Branching disabled.');
          } else if (!foundQuestionToBranchTo) {
            alert('Could not find next question branch. Branching disabled.');
          }
        }
      }
    });

    //var str = options.htmlElement.innerHTML;
    ////console.log("onAfterRenderPage options.htmlelement.innerhtml: " + str);

    //if (str.includes("iframe1")) {
    //    console.log("onAfterRenderPage found iframe1");

    //    //var iframe = this.refs.iframe.getDOMNode();
    //    //if (iframe.attachEvent) {
    //    //    iframe.attachEvent("onload", function () {
    //    //        alert("Local iframe is now loaded.(IE)");
    //    //    });
    //    //} else {
    //    //    iframe.onload = function () {
    //    //        alert("Local iframe is now loaded.(non-IE)");
    //    //    };
    //    //}
    var next = document.getElementsByTagName('input');
    //}
    var iframeelementtest = document.getElementById('payframe');
    if (iframeelementtest != null) {
      if (next) {
        console.log('survey input buttons found with payframe');

        var m = 0;
        for (m = 0; m < next.length; m++) {
          if (
            next[m].value.toLowerCase().localeCompare('next') == 0 ||
            next[m].value.toLowerCase().localeCompare('preview') == 0
          ) {
            next[m].style.display = 'none';
          }
        }
      }

      const local = uuidv4();
      setLocalToken(local);
      //localToken = local;

      //setSurveyExecuteSale(true);
      setSurveyExecuteSaleValid(false);

      var processorID = petitionjson.PaymentProcessorId;
      if (petitionjson.PaymentProcessorId === 2) {
        processorID = 5;
      }

      var firstname = '';
      var lastname = '';
      var address = '';
      var state = '';
      var zip = '';

      //get the values for contactinfo questions from the id, might be better to generate on survey creation instead
      Object.keys(result.data).forEach(function(key) {
        var localAnswer = result.data[key];
        //console.log(localAnswer);
        //console.log('key is: ' + key);
        if (localAnswer.text && localAnswer.text.default) {
          localAnswer = localAnswer.text.default;
        }

        Object.keys(gruquestions).forEach(function(key2) {
          const variable = gruquestions[key2].Variable.toString();
          const qid = gruquestions[key2].Id.toString();

          //console.log('variable is: ' + variable);
          //console.log('qid is: ' + qid);

          switch (variable) {
            case '$FIRST_NAME':
              if (key.toString() === qid) {
                firstname = localAnswer;
              }
              break;

            case '$LAST_NAME':
              if (key.toString() === qid) {
                lastname = localAnswer;
              }
              break;

            case '$ADDRESS':
              if (key.toString() === qid) {
                address = localAnswer;
              }
              break;

            case '$APARTMENT':
              break;

            case '$CITY':
              break;

            case '$STATE':
              if (key.toString() === qid) {
                state = localAnswer;
              }
              break;

            case '$ZIP':
              if (key.toString() === qid) {
                zip = localAnswer;
              }
              break;

            case '$HOME':
              break;

            case '$CELL':
              break;

            case '$EMAIL':
              break;
          }
        });
      });

      const teststring =
        //'http://localhost:52902/PaymentRequestAnon.aspx?' +
        'https://' +
        server +
        '/PaymentRequestAnon.aspx?' +
        'scriptId=' +
        petitionid +
        '&localToken=' +
        encodeURIComponent(local) +
        '&currency=USD' +
        '&imei=' +
        encodeURIComponent(loggedImei) + //'a5c2ab7e5305232') +
        '&recurringPattern=' +
        //encodeURIComponent('ONE-TIME') +
        encodeURIComponent(recurring) +
        '&amount=' +
        //'5' +
        amount.toString() +
        '&Address1=' +
        //encodeURIComponent('123 street') +
        encodeURIComponent(address) +
        '&Address2=' +
        encodeURIComponent('') +
        '&StateProvince=' +
        //encodeURIComponent('PA') +
        encodeURIComponent(state) +
        '&PostalCode=' +
        //encodeURIComponent('19007') +
        encodeURIComponent(zip) +
        '&PaymentProcessorTypeId=' +
        //'5' +
        processorID +
        '&name=' +
        encodeURIComponent(firstname + ' ' + lastname) + //'Dan Test') +
        '&UserName=' +
        encodeURIComponent(loggedUsername);

      //console.log(teststring);

      window.addEventListener('message', addData);

      function addData(e: any) {
        //document.cookie = "myData=" + e.data;
        //alert("message is: " + addData);
        //console.log('message from ' + e.origin);
        //console.log(e.data);
        if (e.origin && String(e.origin).includes('https://' + server.toLowerCase() + '')) {
          console.log('found a message');
          if (e.data && String(e.data).includes('localToken')) {
            console.log('localToken found');
            setSurveyExecuteSaleValid(true);

            for (m = 0; m < next.length; m++) {
              if (
                next[m].value.toLowerCase().localeCompare('next') == 0 ||
                next[m].value.toLowerCase().localeCompare('preview') == 0
              ) {
                next[m].style.display = 'inline';
              }
            }
          } else {
            console.log('localToken not found');
            setSurveyExecuteSaleValid(false);
            alert('Payment is invalid or could not be processed, please try again.');
          }
        } else {
          console.log('did not find ' + 'https://' + server.toLowerCase() + '');
          //executeSale = false;
        }
      }

      //@ts-ignore
      iframeelementtest.src = teststring;
    } else {
      if (next) {
        console.log('survey input buttons found without payframe');

        var m = 0;
        for (m = 0; m < next.length; m++) {
          if (
            next[m].value.toLowerCase().localeCompare('next') == 0 ||
            next[m].value.toLowerCase().localeCompare('preview') == 0
          ) {
            next[m].style.display = 'inline';
          }
        }
      }
    }

    //alternative method for payment frame
    //var iframeelement = document.getElementById('payframe2');
    //if (iframeelement != null) {
    //  //iframeelement.onload = function () {
    //  //console.log('onload iframe1 src:' + iframeelement?.src);
    //  //console.log('onload iframe1 contentwindow: ' + iframeelement.contentWindow.location.href);
    //  //};

    //  var xhr = new XMLHttpRequest();

    //  const local = uuidv4();

    //  //escape() will not encode: @* /+
    //  //encodeURI() will not encode: ~!@#$ &* ()=: /,;?+'
    //  //encodeURIComponent() will not encode: ~!* ()'

    //  xhr.open(
    //    'GET',
    //    'http://localhost:52902/PaymentRequest.aspx?' +
    //      //xhr.open('GET', 'https://staging.grassrootsunwired.com/PaymentRequest.aspx?'
    //      'scriptId=' +
    //      petitionid +
    //      '&localToken=' +
    //      encodeURIComponent(local) +
    //      '&currency=USD' +
    //      '&imei=' +
    //      encodeURIComponent('a5c2ab7e5305232') +
    //      '&recurringPattern=' +
    //      encodeURIComponent('ONE-TIME') +
    //      '&amount=' +
    //      //'5' +
    //      amount.toString() +
    //      '&Address1=' +
    //      encodeURIComponent('123 street') +
    //      '&Address2=' +
    //      encodeURIComponent('apt 32') +
    //      '&StateProvince=' +
    //      encodeURIComponent('PA') +
    //      '&PostalCode=' +
    //      encodeURIComponent('19007') +
    //      '&PaymentProcessorTypeId=' +
    //      '5' +
    //      '&name=' +
    //      encodeURIComponent('Dan Test')
    //  );
    //  //xhr.setRequestHeader('Authorization', 'Basic ' + btoa("x1:a"));
    //  xhr.setRequestHeader('Authorization', 'Bearer ' + sessionStorage.getItem('customg'));
    //  xhr.onreadystatechange = handler;
    //  xhr.send();

    //  function handler() {
    //    if (xhr.readyState === xhr.DONE) {
    //      if (xhr.status === 200) {
    //        // this.response is a Blob, because we set responseType above
    //        //console.log("xhr status 200");
    //        //console.log("xhr.responseText: " + xhr.responseText);
    //        //var localresponse = xhr.responseText.replace("/PaymentResult.aspx", "https://staging.grassrootsunwired.com/PaymentResult.aspx");
    //        //localresponse = localresponse.replace("/PaymentRequest.aspx", "https://staging.grassrootsunwired.com/PaymentRequest.aspx");

    //        var localresponse = xhr.responseText.replace(
    //          '/PaymentResult.aspx',
    //          'http://localhost:52902/PaymentResult.aspx'
    //        );
    //        localresponse = localresponse.replace('/PaymentRequest.aspx', 'http://localhost:52902/PaymentRequest.aspx');

    //        //console.log("xhr.response: " + localresponse);
    //        //xhr.response
    //        //iframeelement.srcdoc = xhr.response;
    //        //@ts-ignore
    //        iframeelement.src = 'data:text/html;charset=utf-8,' + escape(localresponse);
    //        //var data_url = URL.createObjectURL(xhr.response);
    //        //iframeelement.src = xhr.response;
    //        //document.querySelector('#output-frame-id').src = data_url;
    //      } else {
    //        console.log('error handler');
    //      }
    //    }
    //  }

    //  console.log('onAfterRenderPage created iframe1 object');
    //  //var src = iframeelement?.src;
    //  //console.log("created iframe1 src change here: " + src);
    //  //iframeelement.src = "http://localhost:2999";
    //}
  }

  function onAfterRenderQuestion(result: Survey.SurveyModel, options: any) {
    //console.log("onAfterRenderQuestion options.question: " + options.question);
    //console.log("onAfterRenderQuestion options.question.title: " + options.question.title);
    //console.log("onAfterRenderQuestion options.question.name: " + options.question.name);
  }

  function onProcessHtml(result: Survey.SurveyModel, options: any) {
    //console.log("onProcessHtml completed html: " + result.completedHtml);
    //console.log("onProcessHtml options html: " + options.html);

    if (String(options.html).includes('iframe1')) {
      console.log('onProcessHtml found iframe1');
      //var iframeelement = document.getElementById("iframe1");
      //if (!iframeelement) {
      //alert(iframeelement.src);
      //}
    }
  }

  function onCompleting(result: Survey.SurveyModel, options: any) {
    //prevent completion unless survey answers were sent.
    options.allowComplete = false;

    //not working currently with UI updates.
    //setLoadingActive(true);

    //setOpenBackDrop(true);
    console.log('oncompleting');
    //console.log('localToken: ' + localToken);
    //console.log('executeSale: ' + executeSale);

    var Answers: any = [];

    Object.keys(result.data).forEach(function (key) {

      let isArray = false;
      var arrayTemp: any = [];

      var localAnswer = result.data[key];
      if (localAnswer.text && localAnswer.text.default) {
        localAnswer = localAnswer.text.default;
      }

      try {
        //var jsonData = JSON.parse(localAnswer);
        if (Array.isArray(localAnswer)) {
          for (var i = 0; i < localAnswer.length; i++) {
            if (localAnswer[i].text && localAnswer[i].text.default) {
              //localAnswer = jsonData[i].text.default;
              arrayTemp.push(localAnswer[i].text.default);
              isArray = true;
            }
          }
        }
      }
      catch (err) {
        console.log(err.message);
      }
      //set id of Answer if it exists
      Object.keys(gruquestionanswers).forEach(function(keyA) {
        if (!isArray &&
          gruquestionanswers[keyA].Question.toString() === key &&
          gruquestionanswers[keyA].Value.toString() === localAnswer.toString()
        )
        {
          localAnswer = gruquestionanswers[keyA].Id;
        }
        else if (isArray && gruquestionanswers[keyA].Question.toString() === key) {
          for (var i = 0; i < arrayTemp.length; i++) {
            if (gruquestionanswers[keyA].Value.toString() === arrayTemp[i].toString()) {
              arrayTemp[i] = gruquestionanswers[keyA].Id;
            }
          }
        }
      });

      if (isArray) {
        localAnswer = arrayTemp.join().split(',');
        localAnswer = JSON.stringify(localAnswer);
      }

      if (parseInt(key)) {
        //add question answer only if questionid exists
        var Answer = {
          Question: parseInt(key),
          Answer: localAnswer,
        };

        Answers.push(Answer);
      } else {
        //dont push answer
      }
    });

    //hid > 0 not a new survey
    var subjectId = 0;
    if (surveySubject !== null) {
      subjectId = surveySubject.Hid;
    }

    var surveyendtime = getFormattedDate(new Date());

    var SubjectAnswer = {
      Id: petitionid,
      Hid: subjectId,
      Latitude: '33',
      Longitude: '-83',
      Answers: Answers,
      MobileSurveyId: surveyMobileID,
      Time: surveyendtime, //"2020-07-07T10:41:01.9-0400",
      Type: 'Cell',
      Uncertainty: 0,
      SurveyElapsedTime: {
        SurveyStartTime: surveyStartString,
        SurveyEndTime: surveyendtime,
        ElapsedSurveyTime: '0001-01-01T00:00:00'
      }
      //SurveyElapsedTime: { SurveyStart: "2020-07-07T10:41:01", SurveyEndTime: "2020-07-07T10:41:01", ElapsedSurveyTime: "0001-01-01T00:00:00" }
      //Subject: null
    };

    const gruproducts = petitionjson.Products;

    var ItemsTemp: any = [];

    if (gruproducts) {
      //get products from json

      var foundproduct: Boolean = false;

      Object.keys(gruproducts).forEach(function(key) {
        console.log('recurring: ' + recurring);
        console.log('amount: ' + amount.toString());
        console.log(gruproducts[key]);
        if (
          gruproducts[key].Recurring &&
          gruproducts[key].Recurring.toString() === recurring &&
          gruproducts[key].Cost &&
          gruproducts[key].Cost.toString() === amount.toString() &&
          !foundproduct
        ) {
          if (gruproducts[key].Cost && gruproducts[key].Cost > 0 && gruproducts[key].SKU) {
            foundproduct = true;

            var ProductTemp = {};

            //@ts-ignore
            ProductTemp.Cost = amount.toString();
            //@ts-ignore
            ProductTemp.Quantity = 1;
            //@ts-ignore
            ProductTemp.SKU = gruproducts[key].SKU;

            ItemsTemp.push(ProductTemp);
          }
        }
      });

      if (!foundproduct && amount && amount > 0) {
        console.log('no product found yet, but amount > 0');
        Object.keys(gruproducts).forEach(function(key) {
          //console.log('recurring: ' + recurring);
          //console.log('amount: ' + amount.toString());
          //console.log(gruproducts[key]);
          if (
            gruproducts[key].Recurring &&
            gruproducts[key].Recurring.toString() === recurring &&
            gruproducts[key].Cost === null &&
            !foundproduct
          ) {
            if (gruproducts[key].SKU) {
              console.log('found other amount product');

              foundproduct = true;

              var ProductTemp = {};

              //@ts-ignore
              ProductTemp.Cost = amount.toString();
              //@ts-ignore
              ProductTemp.Quantity = 1;
              //@ts-ignore
              ProductTemp.SKU = gruproducts[key].SKU;

              ItemsTemp.push(ProductTemp);
            }
          }
        });
      }
    }

    var PaymentMethodType = 1;
    var AccountNumberTemp = null;
    var RouteNumberTemp = null;

    if (paymentType === 'Check') {
      PaymentMethodType = 2;
      AccountNumberTemp = accountNumber;
      RouteNumberTemp = routeNumber;
    }

    var tempprocessorId = petitionjson.PaymentProcessorId;
    if (tempprocessorId === 2 && PaymentMethodType === 1) {
      tempprocessorId = 5;
    }

    var SubjectAnswerWithCart = {
      Id: petitionid,
      Hid: subjectId,
      Latitude: '33',
      Longitude: '-83',
      Answers: Answers,
      MobileSurveyId: surveyMobileID,
      Time: surveyendtime, //"2020-07-07T10:41:01.9-0400",
      Type: 'Cell',
      Uncertainty: 0,
      SurveyElapsedTime: {
        SurveyStartTime: surveyStartString,
        SurveyEndTime: surveyendtime,
        ElapsedSurveyTime: '0001-01-01T00:00:00',
      },
      Cart: {
        Items: ItemsTemp,
        Serial: null,
        Device: null,
        Track1: null,
        Track2: null,
        Encryptedtrack: null,
        ACHAccount: AccountNumberTemp,
        ABARouting: RouteNumberTemp,
        ACHType: 'Checking',
        Cash: false,
        PaperCheck: false,
        MobileId: localToken,
        NoProcessing: false,
        PaymentProcessorTypeId: tempprocessorId,
        PaymentMethodType: PaymentMethodType,
        PaymentProviderMethod: null,
        Currency: 'USD',
        ClientMetadataId: null,
        MaskedPan: null,
        PaperCheckNumber: null,
        TotalDiscountAmount: null,
        DelayProcessingDate: false,
      },
      //SurveyElapsedTime: { SurveyStart: "2020-07-07T10:41:01", SurveyEndTime: "2020-07-07T10:41:01", ElapsedSurveyTime: "0001-01-01T00:00:00" }
      //Subject: null
    };

    //console.log(SubjectAnswer);

    try {
      if (surveyExecuteSale) {
        if (surveyExecuteSaleValid && amount && amount > 0) {
          function orderId(imei: string) {
            return imei + '-' + getFormattedDateSale(new Date());
          }

          const order = orderId(loggedImei);

          var isHosted = false;
          var tempprocessorId = petitionjson.PaymentProcessorId;
          if (tempprocessorId === 2 && PaymentMethodType === 1) {
            tempprocessorId = 5;
          }
          if (tempprocessorId === 7 && PaymentMethodType === 1) {
            isHosted = true;
          }

          var firstname = '';
          var lastname = '';
          var address = '';
          var state = '';
          var zip = '';

          //get the values for contactinfo questions from the id, might be better to generate on survey creation instead
          Object.keys(result.data).forEach(function(key) {
            var localAnswer = result.data[key];
            //console.log(localAnswer);
            //console.log('key is: ' + key);
            if (localAnswer.text && localAnswer.text.default) {
              localAnswer = localAnswer.text.default;
            }

            Object.keys(gruquestions).forEach(function(key2) {
              const variable = gruquestions[key2].Variable.toString();
              const qid = gruquestions[key2].Id.toString();

              //console.log('variable is: ' + variable);
              //console.log('qid is: ' + qid);

              switch (variable) {
                case '$FIRST_NAME':
                  if (key.toString() === qid) {
                    firstname = localAnswer;
                  }
                  break;

                case '$LAST_NAME':
                  if (key.toString() === qid) {
                    lastname = localAnswer;
                  }
                  break;

                case '$ADDRESS':
                  if (key.toString() === qid) {
                    address = localAnswer;
                  }
                  break;

                case '$APARTMENT':
                  break;

                case '$CITY':
                  break;

                case '$STATE':
                  if (key.toString() === qid) {
                    state = localAnswer;
                  }
                  break;

                case '$ZIP':
                  if (key.toString() === qid) {
                    zip = localAnswer;
                  }
                  break;

                case '$HOME':
                  break;

                case '$CELL':
                  break;

                case '$EMAIL':
                  break;
              }
            });
          });

          var ExecuteSaleData = {
            ScriptId: petitionid,
            OrderId: order,
            //Amount: '5',
            Amount: amount.toString(),
            PaymentMethodType: PaymentMethodType, //1 for cc, 2 for ach
            Currency: 'USD',
            BillingAddress: {
              Name: firstname + ' ' + lastname,
              Address1: address,
              Address2: '',
              City: 'Bristol',
              StateProvince: state,
              PostalCode: zip,
              Country: null,
            },
            AccountInfo: {
              AccountType: 'Checking',
              AccountNumber: AccountNumberTemp, //'123',
              RoutingNumber: RouteNumberTemp, //'123123123',
              Kns: null,
              EncryptedTrack: null,
              Track1: null,
              Track2: null,
              CardExpiryMonth: null,
              CardExpiryYear: null,
              CreditOrDebit: null,
              CardType: null,
            },
            LocalToken: localToken,
            NoProcessing: false,
            //answers by itself will give a bad request
            SurveyData: JSON.stringify(SubjectAnswer), //{ Answers: Answers },//JSON.stringify(Answers),
            MobileSurveyId: surveyMobileID,
            Time: getFormattedDate(new Date()), //"2020-07-07T10:41:01.9-0400",
            IMEI: loggedImei, //'a5c2ab7e5305232',
            RecurringPattern: recurring, //'ONE-TIME', //"Monthly
            PaymentProcessorTypeId: tempprocessorId,
            IsHostedFormPayment: isHosted,
            Uncertainty: 0,
          };

          //console.log(ExecuteSaleData);

          var xhr = new XMLHttpRequest();
          var xhrB = new XMLHttpRequest();
          if (surveyPublic) {
            xhr.open('POST', 'https://' + server + '/api/v2/petition/execute-sale-p', false);
          } else {
            xhr.open('POST', 'https://' + server + '/api/v2/petition/execute-sale', false);
          }
          xhr.setRequestHeader('Authorization', 'Bearer ' + sessionStorage.getItem('customg'));
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.setRequestHeader('imei', loggedImei); //'a5c2ab7e5305232');
          xhr.onreadystatechange = executeSaleHandler;
          xhr.send(JSON.stringify(ExecuteSaleData));
        } else {
          if (amount && amount > 0) {
            alert('Payment has not been verified successfully.  Please submit payment information again.');
          } else {
            alert('Payment amount must be greater than 0.  Please verify payment information.');
          }
        }
      } else {
        //console.log(JSON.stringify(SubjectAnswer));
        var xhrA = new XMLHttpRequest();
        if (surveyPublic) {
          xhrA.open('PUT', 'https://' + server + '/api/v2/petition/answers-p', false);
        } else {
          xhrA.open('PUT', 'https://' + server + '/api/v2/petition/answers', false);
        }
        xhrA.setRequestHeader('Authorization', 'Bearer ' + sessionStorage.getItem('customg'));
        xhrA.setRequestHeader('Content-Type', 'application/json');
        xhrA.setRequestHeader('imei', loggedImei); //'a5c2ab7e5305232');
        xhrA.onreadystatechange = answersHandler;
        xhrA.send(JSON.stringify(SubjectAnswer));
      }
    } catch (err) {
      console.log(err.message);
      options.allowComplete = false;
      setLoadingActive(false);
      if (surveyExecuteSale) {
        console.log('inside initial catch for execute sale');
        if (err.name && err.name.includes('NetworkError')) {
          alert(
            'Failed to send payment information. Please try again after verifying internet connection or server availability.'
          );
        } else {
          alert('Failed to send payment information.');
        }
      } else {
        console.log('inside initial catch for survey answers');
        if (err.name && err.name.includes('NetworkError')) {
          alert(
            'Failed to send survey answers. Please try again after verifying internet connection or server availability.'
          );
        } else {
          alert('Failed to send survey answers.');
        }
      }
    }

    function executeSaleHandler() {
      if (xhr.readyState === xhr.DONE) {
        //(ok, and created)
        if (xhr.status === 200 || xhr.status === 201) {
          //if (executeSale) {
          if (xhr.responseText) {
            var responsejson = null;
            console.log('raw response: ' + xhr.responseText);

            try {
              responsejson = JSON.parse(xhr.responseText);

              console.log(responsejson);
            } catch {}

            //possible litle responses
            //<litleOnlineResponse version="1.0" xmlns="http://www.litle.com/schema" response="3" message="Invalid credentials. Contact eCommerceSupport@vantiv.com."></litleOnlineResponse>
            //<litleOnlineResponse version="8.31" xmlns="http://www.litle.com/schema"
            //  response="0" message="Valid Format">
            //  <echeckSalesResponse id="a5c2ab7e5305232-172848" reportGroup="DanVantiv">
            //    <litleTxnId>83985139175952200</litleTxnId>
            //    <orderId>a5c2ab7e5305232-172848</orderId>
            //    <response>900</response>
            //    <responseTime>2020-11-12T22:28:47</responseTime>
            //    <message>Invalid Bank Routing Number</message>
            //    <postDate>2020-11-12</postDate>
            //  </echeckSalesResponse>
            //</litleOnlineResponse>

            if (!responsejson || !responsejson.Status || responsejson.Status != 1) {
              setLoadingActive(false);
              options.allowComplete = false;
              if (responsejson && responsejson.Message) {
                alert('Payment Failed.  ' + responsejson.Message);
              } else {
                alert('Failed to charge payment. Please try again.');
              }
            } else {
              //setLoadingActive(false);
              //options.allowComplete = false;
              console.log('execute sale successful xhr.responseText' + xhr.responseText);

              try {
                //var xhrB = new XMLHttpRequest();

                if (surveyPublic) {
                  xhrB.open('PUT', 'https://' + server + '/api/v2/petition/answers-p', false);
                } else {
                  xhrB.open('PUT', 'https://' + server + '/api/v2/petition/answers', false);
                }

                xhrB.setRequestHeader('Authorization', 'Bearer ' + sessionStorage.getItem('customg'));
                xhrB.setRequestHeader('Content-Type', 'application/json');
                xhrB.setRequestHeader('imei', loggedImei); //'a5c2ab7e5305232');
                xhrB.onreadystatechange = answersHandlerAfterSale;

                if (responsejson && responsejson.ResponseData) {
                  //@ts-ignore
                  SubjectAnswerWithCart.PaymentResponse = responsejson.ResponseData; //xhr.responseText;
                }

                xhrB.send(JSON.stringify(SubjectAnswerWithCart));
              } catch (err) {
                console.log(err.message);
                options.allowComplete = false;
                setLoadingActive(false);

                alert('Failed to send survey answers. Please try again.');
              }
            }
          } else {
            setLoadingActive(false);
            options.allowComplete = false;
            alert('Failed to charge payment. Please try again.');
          }
          //} else {
          //  // this.response, need to set responseType
          //  console.log('survey successful xhr.responseText: ' + xhr.responseText);
          //  setLoadingActive(false);

          //  if (subjectId > 0) {
          //    let currentSubjectList = walklistjson;
          //    currentSubjectList.Walklist.filter(function(data: any) {
          //      return data.Hid == subjectId;
          //    })[0].Status = '14'; //`${status}`;
          //    setWalklist(currentSubjectList);
          //  }
          //}
          //document.querySelector('#backdrop').src = data_url;
          //setOpenBackDrop(false);
          //setOpenSnackSuccess(true);
        } else {
          console.log('non 200 answers response');
          options.allowComplete = false;
          setLoadingActive(false);
          //if (executeSale) {

          if (xhr.status === 412 || xhr.status === 409) {
            alert(
              'Failed to send payment information. Subject has already been surveyed or survey has already been sent. Please begin a new survey.'
            );
          } else {
            alert('Failed to send payment information. Please try again.');
          }

          //} else {
          //  alert('Failed to send survey answers. Please try again.');
          //}
          //setOpenBackDrop(false);
          //setOpenSnackFail(true);
        }
      }
    }

    function answersHandler() {
      if (xhrA.readyState === xhrA.DONE) {
        //precondition failed (dupe survey, ok, and created)
        if (xhrA.status === 200 || xhrA.status === 201) {
          // this.response, need to set responseType
          console.log('survey successful xhr.responseText: ' + xhrA.responseText);
          setLoadingActive(false);

          if (!surveyPublic && subjectId > 0 && walklistjson && walklistjson.Walklist) {
            let currentSubjectList = walklistjson;
            currentSubjectList.Walklist.filter(function(data: any) {
              return data.Hid == subjectId;
            })[0].Status = '14'; //`${status}`;
            setWalklist(currentSubjectList);
          }

          options.allowComplete = true;

          //document.querySelector('#backdrop').src = data_url;
          //setOpenBackDrop(false);
          //setOpenSnackSuccess(true);
        } else {
          console.log('non 200 answers response');
          options.allowComplete = false;
          setLoadingActive(false);
          //if (executeSale) {
          //  alert('Failed to send payment information. Please try again.');
          //} else {
          if (xhrA.status === 412 || xhrA.status === 409) {
            alert(
              'Failed to send survey answers. Subject has already been surveyed or survey has already been sent. Please begin a new survey.'
            );
          } else {
            alert('Failed to send survey answers. Please try again.');
          }
          //}
          //setOpenBackDrop(false);
          //setOpenSnackFail(true);
        }
      }
    }

    function answersHandlerAfterSale() {
      if (xhrB.readyState === xhrB.DONE) {
        //precondition failed (dupe survey, ok, and created)
        if (xhrB.status === 200 || xhrB.status === 201) {
          // this.response, need to set responseType
          console.log('survey successful xhr.responseText: ' + xhrB.responseText);
          setLoadingActive(false);

          if (!surveyPublic && subjectId > 0 && walklistjson && walklistjson.Walklist) {
            let currentSubjectList = walklistjson;
            currentSubjectList.Walklist.filter(function(data: any) {
              return data.Hid == subjectId;
            })[0].Status = '14'; //`${status}`;
            setWalklist(currentSubjectList);
          }

          options.allowComplete = true;

          //document.querySelector('#backdrop').src = data_url;
          //setOpenBackDrop(false);
          //setOpenSnackSuccess(true);
        } else {
          console.log('non 200 answers response');
          options.allowComplete = false;
          setLoadingActive(false);
          //if (executeSale) {
          //  alert('Failed to send payment information. Please try again.');
          //} else {
          if (xhrB.status === 412 || xhrB.status === 409) {
            alert(
              'Failed to send survey answers. Subject has already been surveyed or survey has already been sent. Please begin a new survey.'
            );
          } else {
            alert('Failed to send survey answers. Please try again.');
          }
          //}
          //setOpenBackDrop(false);
          //setOpenSnackFail(true);
        }
      }
    }

    //Another method but it is async: Need to do in this order: Send -> Then -> Catch
    //    try {
    //        sendAnswersLocal(SubjectAnswer)

    //            .then((res) => {
    //                console.log("onCompleting res return successful: " + res);
    //            //alert("successfully sent survey results");
    //                //setSurveyComplete(true);
    //            //options.allowComplete = true;
    //                //surveycomplete = true;
    //                //result.completeLastPage();
    //            //if (complete) {
    //            //    alert("successfully sent survey results");
    //            //    setSurveyComplete(true);
    //            //    result.completeLastPage();
    //            //}
    //            //else { alert("unable to send survey results"); }
    //            })
    //        .catch ((error) => { console.log("onCompleting sendAnswersLocal error catch: " + error.message); })
    //    } catch (error) {
    //        //options.allowComplete = false;
    //        console.log("onCompleting error catch: " + error.message);
    //    }
  }

  //function sendAnswersLocal(SubjectAnswer: any) {
  //  return Promise.all([sendAnswers(loggedUsername, '', SubjectAnswer)]);
  //}

  function onComplete(result: Survey.SurveyModel, options: any) {
    //console.log("Complete! " + result);
    //result.completedHtml = "<div>Survey sent successfully</div>"
  }

  const [openBackDrop, setOpenBackDrop] = React.useState(false);
  const handleCloseBackDrop = () => {
    setOpenBackDrop(false);
  };
  const handleToggleBackDrop = () => {
    setOpenBackDrop(!openBackDrop);
  };

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const handleCloseSnackSuccess = (event: any, reason: any) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackSuccess(false);
  };

  const [openSnackFail, setOpenSnackFail] = React.useState(false);
  const handleCloseSnackFail = (event: any, reason: any) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackFail(false);
  };

  const [loadingActive, setLoadingActive] = useState(false);

  return (
    <div>
      <LoadingOverlay active={loadingActive} spinner={<BounceLoader />} text="Loading" className={classes.loading}>
        <div className={classes.survey}>
          <Survey.Survey
            model={surveyModel}
            //onComplete={onComplete}
            onCompleting={onCompleting}
            onValueChanged={onValueChanged}
            onCurrentPageChanging={onCurrentPageChanging}
            //onProcessHtml={onProcessHtml}
            onAfterRenderPage={onAfterRenderPage}
            //onAfterRenderQuestion={onAfterRenderQuestion}
          />
        </div>
        <Backdrop className={classes.backdrop} open={openBackDrop} onClick={handleCloseBackDrop}>
          <CircularProgress color="inherit" />
        </Backdrop>
        {/*<Snackbar open={openSnackSuccess} autoHideDuration={5000} onClose={handleCloseSnackSuccess}>
              <Alert onClose={handleCloseSnackSuccess} severity="success">
                      Survey Sent Successfully
              </Alert>
              </Snackbar>
              <Snackbar open={openSnackFail} autoHideDuration={5000} onClose={handleCloseSnackFail}>
              <Alert onClose={handleCloseSnackFail} severity="error">
                      Survey Sent Successfully
              </Alert>
              </Snackbar>*/}

        {/*<Typography>petition</Typography>*/}
      </LoadingOverlay>
    </div>
  );
}
